import {Link} from 'react-router';
import clsx from 'clsx';
import {useSettings} from '@ui/settings/use-settings';

// CUSTOM(albaniantheatre): CSS/text based site logo with comedy & tragedy
// masks icon, rendered instead of the image logo from appearance settings
// (used with `hideLogo` on the shared Navbar component). If a different logo
// is uploaded in admin > Appearance > General, that image wins so the
// standard upload flow keeps working.
interface Props {
  className?: string;
}
export function AlbanianTheatreLogo({className}: Props) {
  const {branding} = useSettings();
  const uploadedLogo =
    branding.logo_light && !branding.logo_light.includes('albanian-theatre')
      ? branding.logo_light
      : null;

  if (uploadedLogo) {
    return (
      <Link
        to="/"
        aria-label="Go to homepage"
        className={clsx('block h-full max-h-36 flex-shrink-0', className)}
      >
        <img src={uploadedLogo} className="block h-full w-auto" alt="" />
      </Link>
    );
  }

  return (
    <Link
      to="/"
      aria-label="Albanian Theatre - go to homepage"
      className={clsx(
        'flex flex-shrink-0 select-none items-center gap-10',
        className,
      )}
    >
      <ComedyTragedyMasksIcon className="h-34 w-auto flex-shrink-0" />
      <span className="flex flex-col justify-center whitespace-nowrap leading-none">
        <span className="font-serif text-lg font-semibold leading-none">
          Albanian
        </span>
        <span className="mt-4 text-[10px] font-semibold uppercase leading-none tracking-[0.3em] text-[#e7b94c]">
          Theatre
        </span>
      </span>
    </Link>
  );
}

function ComedyTragedyMasksIcon({className}: {className?: string}) {
  return (
    <svg
      viewBox="0 0 66 50"
      aria-hidden="true"
      className={className}
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* tragedy mask (back) */}
      <g stroke="currentColor">
        <path d="M5 4.5 C12.5 1.8 22.5 1.8 30 4.5 C30 4.5 31.8 22 26.5 30.5 C23.3 35.7 11.7 35.7 8.5 30.5 C3.2 22 5 4.5 5 4.5 Z" />
        <path d="M10.5 14 Q13 11.5 15.5 14" />
        <path d="M19.5 14 Q22 11.5 24.5 14" />
        <path d="M12 26.5 Q17.5 21 23 26.5" />
      </g>
      {/* comedy mask (front) */}
      <g stroke="#e7b94c">
        <path d="M36 16.5 C43.5 13.8 53.5 13.8 61 16.5 C61 16.5 62.8 34 57.5 42.5 C54.3 47.7 42.7 47.7 39.5 42.5 C34.2 34 36 16.5 36 16.5 Z" />
        <path d="M41.5 26 Q44 23.5 46.5 26" />
        <path d="M50.5 26 Q53 23.5 55.5 26" />
        <path d="M43 34 Q48.5 40 54 34" />
      </g>
    </svg>
  );
}
